export const SunkevMark = ({ size = 40 }) => (
  <img
    src="/assets/sunkev-mark.png"
    alt=""
    style={{ height: size, width: "auto" }}
    aria-hidden="true"
  />
);

export const SunkevLogo = ({ dark = false, compact = false }) => (
  <div className="flex items-center gap-3" data-testid="sunkev-logo">
    <SunkevMark size={compact ? 36 : 42} />
    <div className="leading-tight">
      <span
        className={`block font-heading text-lg font-bold tracking-tight ${
          dark ? "text-white" : "text-navy"
        }`}
      >
        Sunkev Enterprises
      </span>
      <span
        className={`block text-[10px] font-medium uppercase tracking-[0.28em] ${
          dark ? "text-white/60" : "text-fog"
        }`}
      >
        Private Limited
      </span>
    </div>
  </div>
);

export const CraftsiLogo = ({ large = false }) => (
  <div className="flex items-center gap-3" data-testid="craftsi-logo">
    <img
      src="/assets/craftsi-logo-navy.png"
      alt="Craftsi logo"
      className={`w-auto ${large ? "h-16" : "h-11"}`}
    />
    <span
      className={`rounded-full bg-navy font-heading font-extrabold tracking-tight text-white ${
        large ? "px-7 py-2.5 text-3xl" : "px-5 py-1.5 text-xl"
      }`}
    >
      craftsi
    </span>
  </div>
);
